import { BASE_DOMAINS, Stage } from "./consants";

export const isDomainDev = (domain: string): boolean => {
  return domain.includes(".aws.dev");
};

export const isDomainProd = (domain: string): boolean => {
  return !isDomainDev(domain);
};

export const getStageFromDomain = (domain: string): Stage => {
  for (const stage of ["alpha", "beta", "gamma"] as Stage[]) {
    if (domain.indexOf(`${stage}`) !== -1) {
      return stage;
    }
  }
  return "prod";
};

export const getAuthURLFromDomain = (domain: string): string => {
  const stage = getStageFromDomain(domain);
  if (stage === "prod") {
    return `https://${BASE_DOMAINS.prod.auth}`;
  }
  return `https://${stage}${BASE_DOMAINS.dev.auth}`;
};

export const getBPURLFromDomain = (domain: string): string => {
  const stage = getStageFromDomain(domain);
  if (stage === "prod") {
    return `https://${BASE_DOMAINS.prod.bpGlobal}`;
  } else {
    return `https://${BASE_DOMAINS.dev.bpGlobal}`;
  }
};
